import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-modal-item-actions',
    templateUrl: './modal-item-actions.shared.component.html',
    styleUrls: ['./modal-item-actions.shared.component.scss']
})
export class ModalItemActionsComponent implements OnInit {
    @Input() public isCtaVisible: boolean = true;
    @Input() public isQuantityVisible: boolean = true;

    @Input() public quantity: number; /* Consumer -> quantity */
    @Input() public disabled: boolean = false; /* Consumer -> quantity */
    @Input() public max: number = 9999; /* Consumer -> quantity */
    @Input() public remove: boolean = false; /* Consumer -> quantity */
    @Input() public minimumHide: boolean = true; /* Consumer -> quantity */
    @Input() public size: OLO.Components.BUTTON_SIZE = 'lg'; /* Consumer -> shared-btn, shared-quantity */
    @Input() public empty: boolean = false;

    @Input() public buttonLabel: string; /* Add to bag, Edit item, No, thanks. Consumer -> button */
    @Input() public buttonPrice: number = null /* $0.00. Consumer -> button */;

    @Input() public twoColumnsAlign: OLO.Components.TWO_COLUMNS_ALIGN = 'center'; /* Consumer -> shared-two-columns */
    @Input() public twoColumnsAdjust: OLO.Components.TWO_COLUMNS_ADJUST; /* Consumer -> shared-two-columns */
    @Input() public twoColumnsMarginBottom: OLO.Components.MARGIN_SIZE = 'none'; /* Consumer -> shared-two-columns */
    @Input() public twoColumnsMobileLeft: boolean = false; /* Consumer -> shared-two-columns */
    @Input() public twoColumnsMobileRight: boolean = true; /* Consumer -> shared-two-columns */

    @Output() public onDecrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onIncrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onRemove: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void { }

    public handleIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onIncrement.emit($event);
    }

    public handleDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onDecrement.emit($event);
    }

    public handleRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onRemove.emit($event);
    }

    public handleCtaClick($event: Event): void {
        this.onClick.emit($event);
    }
}
